import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import ProfileIntakeForm from '../../components/profiles/intake/ProfileIntakeForm'
import PrePopulateProfileIntakeForm from '../../components/profiles/intake/PrePopulateProfileIntakeForm'
import { loadIntakeForm } from '../../actions/profileIntakeActions'
import { updatePageTitle } from '../../actions/pageInfo'

const model = 'localOpportunities.profileLoad.form'
const ProfileCreationContainer = props => {
  const params = useParams()
  const { dispatch, prePopulate, additionalJson } = props

  useEffect(() => {
    dispatch(loadIntakeForm(params.intakeFormId)).then(r => {
      dispatch(updatePageTitle(r.title))
    })
  }, [params.intakeFormId])

  console.log(props)

  const renderContent = () => {
    console.log(props)

    if (prePopulate) {
      if (!additionalJson) {
        return <PrePopulateProfileIntakeForm />
      }

      return <ProfileIntakeForm />
    }

    return <ProfileIntakeForm />
  }

  return (
    <div className="container profile-creation-intake" id="profileinfocontainer">
      {renderContent()}
    </div>
  )
}

export default connect(
  state => {
    return {
      prePopulate: state.localOpportunities.profileLoad.data.result.prePopulate,
      additionalJson: state.localOpportunities.profileLoad.data.additionalJson
    }
  },
  dispatch => ({
    dispatch
  })
)(ProfileCreationContainer)
